
/* add class on scroll */

(function ($, app, _) {
    "use strict";

    app.AddClassScroll = function () {

        //caches a jQuery object containing the header element
        var header = $(".clearHeader");
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            if (scroll >= 200) {
                $('.site-header').addClass("scrolled");
            } else {
                $('.site-header').removeClass("scrolled");
            }
        });
    };

})(jQuery, app, _);


jQuery(document).ready(function() {
    jQuery(window).scroll(function() {
        $('.dark-back').hide();
        $('.dark-back-top').hide();
        $(".dropdown").removeClass("show");
        $(".dropdown-menu").removeClass("show");
    });
});


$(document).ready(function() {
    var maxHeight = -1;
    $('.same-height').each(function() {
        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
    });
    $('.same-height').each(function() {
        $(this).height(maxHeight);
    });
});